import React from "react";
import { styled } from "styled-components";
import Colors from "../../styles/Colors";
import { InputText } from "../Text";
import idGenerator from "../../utils/idGenerator";
const SwitchLabel = styled.label `
  --border-color: ${Colors.GRAY};
  --bg-color: ${Colors.WHITE};
  --switch-color: ${Colors.GRAY};

  display: flex;
  align-items: center;

  &,
  > input {
    cursor: ${(props) => (props.isDisabled ? "not-allowed" : "pointer")};
  }

  &:hover > input:not(:disabled),
  &:hover > input:checked {
    --border-color: ${Colors.PROFILE_RED_2024};
    --bg-color: ${Colors.LIGHT_RED_2024};
    --switch-color: ${Colors.PROFILE_RED_2024};

    box-shadow: inset 0 0 0 1px ${Colors.PROFILE_RED_2024},
      0 0 0 4px ${Colors.LIGHT_RED_2024};
  }

  > input {
    position: relative;
    appearance: none;
    border: none;
    padding: 0 3rem 0 0;
    margin: 0 0.75rem 0 0;
    width: 3.25rem;
    height: 2rem;
    background-color: var(--bg-color);
    box-shadow: inset 0 0 0 1px var(--border-color);
    border-radius: 1rem;
    transition: background ease 0.1s, box-shadow ease 0.1s;

    &::after {
      position: absolute;
      content: "";
      top: 0.25rem;
      left: 0.25rem;
      width: 1.5rem;
      height: 1.5rem;
      background-color: var(--switch-color);
      border-radius: 0.75rem;
      transition: transform ease 0.1s, background ease 0.1s;
    }

    &:checked {
      --border-color: ${Colors.PROFILE_RED_2024};
      --bg-color: ${Colors.LIGHT_RED_2024};
      --switch-color: ${Colors.PROFILE_RED_2024};

      &::after {
        transform: translateX(calc(100% - 0.25rem));
      }
    }

    &:disabled {
      --border-color: ${Colors.GRAY_LIGHT};
      --bg-color: ${Colors.GRAY_LIGHT};
      --switch-color: ${Colors.GRAY};

      &::after {
        opacity: 0.33;
      }
    }
  }
`;
export const Switch = ({ label, disabled, ...props }) => {
    const [inputId] = React.useState(() => props.id ?? idGenerator("fjordline-switch-"));
    return (React.createElement(SwitchLabel, { htmlFor: inputId, isDisabled: disabled ?? false },
        React.createElement("input", { type: "checkbox", id: inputId, disabled: disabled, ...props }),
        React.createElement(InputText, null, label)));
};
export default Switch;
//# sourceMappingURL=LightSwitch.js.map